import { render, staticRenderFns } from "./PromoCategoryRow.vue?vue&type=template&id=21da004f&scoped=true"
import script from "./PromoCategoryRow.vue?vue&type=script&lang=js"
export * from "./PromoCategoryRow.vue?vue&type=script&lang=js"
import style0 from "./PromoCategoryRow.vue?vue&type=style&index=0&id=21da004f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da004f",
  null
  
)

export default component.exports